import React from "react";
import { Spinner } from "react-bootstrap";
import { APP_BRAND_FOLDER } from "../utils/consts";

const LoadingScreen = () => {
  return (
    <>
      {/* 
        We load the Xchange logo inline so it displays instantly when the 
        Loading Screen renders 
      */}
      <img
        src={`/brands/${APP_BRAND_FOLDER}/img/loadingscreen@2x.png`}
        width="250"
        alt="RealXchange"
      />
      <p>Loading Meeting Suite...</p>
      <div>
        <Spinner animation="border" role="status" />
      </div>
    </>
  );
};

export default LoadingScreen;
